interface FilterGroupProps {
  label: string;
  options: string[];
  value: string;
  onChange: (value: string) => void;
}

export default function FilterGroup({ label, options, value, onChange }: FilterGroupProps) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="shrink-0 text-xs font-500 text-foreground-500">{label}</span>
      <div className="flex flex-wrap gap-1.5">
        {options.map((option) => {
          const active = option === value;
          return (
            <button
              key={option}
              type="button"
              onClick={() => onChange(option)}
              className={`cursor-pointer whitespace-nowrap rounded-md px-3 py-1.5 text-xs transition-colors ${
                active
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-700 hover:text-primary-400"
              }`}
            >
              {option}
            </button>
          );
        })}
      </div>
    </div>
  );
}